import React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import styles from './GrowthTrackingTab.module.css';

const DownloadReport = ({ filterdata }) => {
  const { sendReq: fetchData } = useHttp();

  const handleDownload = () => {
    const requestBody = { filterdata };

    // 📌 First API: Energy Efficiency
    fetchData(
      {
        url: API_URL_MAIN + 'Ace_Growth_tracking/energy_efficiency_score',
        body: requestBody
      },
      (energyResult) => {
        if (energyResult) {
          // 📌 Second API: Improved/Not Improved
          fetchData(
            {
              url: API_URL_MAIN + 'Ace_Growth_tracking/growth_tracking_improved_notimproved',
              body: requestBody
            },
            (vehicleResult) => {
              if (vehicleResult && Array.isArray(vehicleResult) && vehicleResult.length) {
                const latestEntry = vehicleResult.reduce((latest, current) => {
                  return new Date(current.month + '-01') > new Date(latest.month + '-01') ? current : latest;
                }, vehicleResult[0]);

                const energyData = [
                  {
                    'Energy Efficiency Score': energyResult.energyEfficiencyScore,
                    'Latest Month': latestEntry.month,
                    'Vehicles Improved': latestEntry.improved_vehicle_count || '0',
                    'Vehicles Not Improved': latestEntry.not_improved_vehicle_count || '0'
                  }
                ];

                const workbook = XLSX.utils.book_new();
                const energySheet = XLSX.utils.json_to_sheet(energyData);
                XLSX.utils.book_append_sheet(workbook, energySheet, 'Energy Report');

                // 📌 Fetch VIN List
                fetchData(
                  {
                    url: API_URL_MAIN + 'Ace_Growth_tracking/get_all_vin_num',
                    body: { IND: 'VIN_NUM', filterdata }
                  },
                  (vinResult) => {
                    const vinList = vinResult?.unique_vehicles?.buckets.map(item => item.key.value) || [];

                    // 📌 Fetch Reg No List
                    fetchData(
                      {
                        url: API_URL_MAIN + 'Ace_Growth_tracking/get_all_reg_num',
                        body: { IND: 'REG_NUM', filterdata }
                      },
                      (regResult) => {
                        const regList = regResult?.unique_vehicles?.buckets.map(item => item.key.value) || [];

                        // 📌 Combine VIN & Reg pairs
                        const combinedList = vinList.map((vin, index) => ({
                          vin,
                          reg: regList[index] || ''
                        }));

                        // 📌 Fetch Parameter Comparison
                        fetchData(
                          {
                            url: API_URL_MAIN + 'Ace_Growth_tracking/parameter_comparison',
                            body: requestBody
                          },
                          (paramResult) => {
                            if (paramResult) {
                              const paramMap = {
                                'averageOfSpeed': 'Speed',
                                'Accelarator Pedal': 'Accelerator Pedal',
                                'Fuel Efficiency': 'Fuel Efficiency',
                                'GSA': 'GSA',
                                'Top Gear': 'Top Gear',
                                'Neutral Running': 'Neutral Running',
                                'Idling': 'Idling',
                                'RPM Band': 'RPM Band',
                                'Cruising': 'Cruising'
                              };

                              const finalArray = [];

                              combinedList.forEach(vehicle => {
                                const vinData = paramResult[vehicle.vin];

                                Object.entries(paramMap).forEach(([apiParamKey, displayParam]) => {
                                  const comp = vinData?.comparison?.[apiParamKey];
                                  if (comp) {
                                    finalArray.push({
                                      'Vin No': vehicle.vin,
                                      'Reg. No': vehicle.reg,
                                      'Last Month': 'Jun-25',
                                      'Current Month': 'Jul-25',
                                      'Key Param': displayParam,
                                      'Last Month Performance': (comp.previousMonthValue * 100).toFixed(2) + '%',
                                      'Current Month Performance': (comp.currentMonthValue * 100).toFixed(2) + '%'
                                    });
                                  }
                                });
                              });

                              const combinedSheet = XLSX.utils.json_to_sheet(finalArray);
                              XLSX.utils.book_append_sheet(workbook, combinedSheet, 'Last Month');

                              // ✅ Final Download
                              const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                              const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
                              saveAs(data, 'Growth_Tracking_Report.xlsx');
                            } else {
                              alert('No Parameter data found.');
                            }
                          }
                        );
                      }
                    );
                  }
                );
              } else {
                alert('No vehicle improvement data found.');
              }
            }
          );
        } else {
          alert('No energy efficiency data found.');
        }
      }
    );
  };

  return (
     <div className={styles.downloadBtnContainer}>
    <button onClick={handleDownload} className={styles.downloadBtn}>
      Download Report
    </button>
    </div>
  );
};

export default DownloadReport;
